var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSidebarTab',{attrs:{"id":_vm.id,"icon":_vm.icon,"name":_vm.name,"active-tab":_vm.activeTab}})}
var staticRenderFns = []

export { render, staticRenderFns }